import { StepApplicantsElement } from '@models/applicants';
import { StepsCounter, StepsElement } from '@models/steps';
import axiosInstance from '../../utils/http-client';

const getAllSteps = (position: string): Promise<StepsElement> => {
  return axiosInstance.get(`/api/v1/app/positions/${position}/workflow-steps`, {});
};

export const getStepsCounter = (position: string): Promise<StepsCounter> => {
  return axiosInstance.get(`/api/v1/app/positions/${position}/workflow-steps/applicants-count`, {});
};

export const getActiveApplicants = (position: string): Promise<StepApplicantsElement> => {
  return axiosInstance.get(`/api/v1/app/positions/${position}/workflow-steps/applicants?status=active`, {});
};

export const getRejectedApplicants = (position: string, step: string): Promise<StepApplicantsElement> => {
  return axiosInstance.get(`/api/v1/app/positions/${position}/workflow-steps/${step}/applicants?status=rejected`, {});
};

export const updateStep = (position: string, stepId: string, applicantId: string): Promise<number> => {
  return axiosInstance.put(`/api/v1/app/positions/${position}/workflow-steps/applicant`, {
    applicantId,
    stepId,
  });
};

export const updateStepTitle = (position: string, step: string, stepTitle: string): Promise<number> => {
  return axiosInstance.put(`/api/v1/app/positions/${position}/workflow-steps/${step}`, {
    stepTitle,
  });
};

export default getAllSteps;
